/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("content-templates/content-gallery/system/contentSystemTableLayout.tmpl");
    var Button = require("ui/button/Button");
    var Paging = require("ui/paging/Paging");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");

    var ContentSystemTableLayout = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemTableLayout = Marionette.Layout.extend({
            template: template,
            className: "content-gallery-layout",
            isPermanent: true,
            regions: {
                tableRegion          : ".table-container",
                dialogContainerRegion: ".dialog-container"
            },
            ui: {
                actionMenuContainer       : ".action-menu"
            },
            uiComponents: {
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        align: DropdownMenu.ALIGN.RIGHT,
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionsCollection",
                        tabindex: "1000",
                        nowrap: true
                    },
                    events: {
                        "change":"_onActionSelected"
                    }
                }
            },

            initialize: function (options) {
                options = options || {};
                this.channel = options.channel;
                this.isAcUser = options.isAcUser;
            },
            onRender: function () {
                this.$el.toggleClass("type-" + this.model.getType(),true);
                LEContent.logger.debug("onRender ContentSystemTableLayout", "ContentSystemTableLayout:onRender");
            },
            onClose: function () {
                LEContent.logger.info("closing content gallery layout view", "ContentSystemTableLayout::onClose");
            },
            /**
             * Returns a collection of the action menu items
             * @returns {DropdownMenu.Collection}
             * @private
             */
            _getActionsCollection: function() {
                return this.model.getActions();
            },

            _getGalleryCollection: function () {
                return this.model.getOrganizedCollection();
            },
            /**
             * Handles the selected action
             * @param id
             */
            _onActionSelected: function(componentId, eventName, id){
                LEContent.logger.info("Content table: user clicked on menu action: " + id, "ContentSystemTableLayout:onActionSelected");
                switch (id) {
                    case "edit":
                        this.channel.trigger("contentSystemTableLayout:actions:edit");
                        break;
                    default:
                        break;
                }
            }
        });
    });
    return ContentSystemTableLayout;
});
